export enum SessionStorageKeys {
  // Read once + cleared by the ElevenLabs app on /music mount to pre-fill its
  // creation omnibox. Owned by the app repo (services/js/app/utils/storage.ts
  // → SessionStorageKeys.OMNIBOX_MUSIC_PROMPT); keep this value in sync. Relies
  // on marketing + app being same-origin so a same-tab navigation preserves it.
  OMNIBOX_MUSIC_PROMPT = "xi-tab-state:omnibox-music-prompt",
}

/**
 * Writes to sessionStorage, silently no-opping when it's unavailable (SSR),
 * access is denied (SecurityError), or quota is exceeded.
 */
export const setSessionStorage = (key: SessionStorageKeys, value: string) => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // sessionStorage unavailable, access denied, or quota exceeded
  }
};
